/**
 * 事件通讯
 * https://www.npmjs.com/package/tiny-emitter
 */
import Emitter from 'tiny-emitter';
export const emitter = new Emitter();
export default emitter;

// 事件定义
export const EMIT_DEFINE = {
  navStepClick: 'navStepClick', // 导航步骤条点击事件

  VodAIHighlightComplete: 'vod_ai_moments_complete', // 精彩时刻创建完成
  VodAISummaryComplete: 'vod_ai_summary_complete', // 概要总结创建完成

  changeMomentEdit: 'changeMomentEdit', // 精彩时刻-是否可以打点
  addMomentsItem: 'addMomentsItem', // 精彩时刻-发送打点的数据事件
  addMomentsCutImage: 'addMomentsCutImage', // 精彩时刻-发送打点的截图事件
  endMomentsItem: 'endMomentsItem', // 精彩时刻-发送打点数据完成的事件
  endMomentsCutImage: 'endMomentsCutImage', // 精彩时刻-截图结束事件
  changeMomentFilter: 'changeMomentFilter', // 精彩时刻-添加提示遮罩
  momentCurrentTimeClick: 'momentCurrentTimeClick', // 精彩时刻-点击右侧时间事件

  doVideoAction: 'doVideoAction', //让视频的执行的一些基础操作
  videoTimeUpdate: 'videoTimeUpdate', // 视频播放位置更新时触发事件

  videoAsrEditTextChange: 'videoAsrEditTextChange', // 智能解析 - 编辑文本变更
  videoAsrTextUpdate: 'videoAsrTextUpdate', // 智能解析 - 文本最终变更(解析后 和 校正完成后保存)

  videoSubtitlesUpdate: 'videoSubtitlesUpdate', // 智能字幕 - 更新点播字幕内容
  videoSubtitlesCssUpdate: 'videoSubtitlesCssUpdate', // 智能字幕 - 更新点播字幕样式

  clipAddItem: 'clipAddItem', // 精彩剪辑
  clipAddGuide: 'clipAddGuide', // 精彩剪辑 - 我要添加

  msgVodAiParsingAsrComplete: 'msgVodAiParsingAsrComplete', // 智能解析完成消息
  msgVodAiClipComplete: 'msgVodAiClipComplete', // 精彩剪辑-创作完成消息
  msgVodAiClipCustomAddComplete: 'msgVodAiClipCustomAddComplete', // 精彩剪辑-新增片段完成回调
  msgVodAiClipDownloadProgress: 'msgVodAiClipDownloadProgress', // 精彩剪辑- 打包进度
  msgVodAiClipDownloadComplete: 'msgVodAiClipDownloadComplete', // 精彩剪辑- 打包完成
  msgVidoeTransStatus: 'msgVidoeTransStatus' // 音视频上传后，转码进度消息通知
};
